<template>
  <el-tooltip :effect="effect" :content="content" :placement="placement">
    <slot></slot>
  </el-tooltip>
</template>
<script>
export default {
  props: {
    placement: {
      default: "top",
      type: String,
    },
    content: {
      default: "",
      type: String,
    },
    effect: {
      default: "dark",
      type: String,
    },
  },
};
</script>
